import type { Tenant } from "../../api/types";
import { WIZARD_STEPS } from "../../lib/labels";
import { Link } from "../../router/router";

/**
 * Die sieben Schritte oben: erledigte mit Haken und als Link, der aktuelle
 * hervorgehoben. „Erreicht" ist der weiteste gespeicherte Schritt.
 */
export function StepsNav({ tenant, current }: { tenant: Tenant | null; current: number }) {
  const reached = tenant ? Math.max(tenant.wizard_step, current) : 1;
  return (
    <ol className="pf-steps">
      {WIZARD_STEPS.map((label, i) => {
        const n = i + 1;
        const cls = n === current ? " pf-steps__item--current" : n < reached ? " pf-steps__item--done" : "";
        const inner = <><span className="pf-steps__num">{n < reached && n !== current ? "✓" : n}</span>{label}</>;
        return (
          <li key={label} className={`pf-steps__item${cls}`}>
            {tenant && n <= reached && n !== current ? <Link to={`/tenants/${tenant.id}/wizard/${n}`}>{inner}</Link> : inner}
          </li>
        );
      })}
    </ol>
  );
}
